import Frequency from "./Frequency";
import Payment from "./Payment";
import Expiry from "./Expiry";
import { GetSignedAgreementQuery } from "src/generated/graphql";

interface IEditSignedAgreementProps {
  modalId: string;
  clientId?: string;
  onRefetch: () => void;
  agreement?: GetSignedAgreementQuery["signedAgreementOne"];
}

export const EditModalsList = {
  FREQUENCY: {
    id: "FREQUENCY",
    title: "Change Frequency",
  },
  PAYMENT: {
    id: "PAYMENT",
    title: "Payment Details",
  },
  EXPIRY: {
    id: "EXPIRY",
    title: "Expiry Details",
  },
};

const EditSignedAgreement = ({
  modalId,
  clientId,
  agreement,
  onRefetch,
}: IEditSignedAgreementProps) => {
  const EditComponents = [
    {
      id: EditModalsList.FREQUENCY.id,
      component: (
        <Frequency
          subscriptionId={agreement?.subscription.id!}
          frequency={agreement?.subscription.paymentFrequency!}
          onRefetch={onRefetch}
        />
      ),
    },
    {
      id: EditModalsList.PAYMENT.id,
      component: (
        <Payment
          clientId={clientId ? clientId : ""}
          signedAgreementId={agreement?.id!}
          selectedPaymentMethod={agreement?.paymentMethod?.id}
          onRefetch={onRefetch}
        />
      ),
    },
    {
      id: EditModalsList.EXPIRY.id,
      component: (
        <Expiry
          signedAgreementId={agreement?.id!}
          expiresAt={new Date(agreement?.termEnd)}
          onRefetch={onRefetch}
        />
      ),
    },
  ];

  let EditModal = EditComponents.find((e) => e.id === modalId);

  return <>{EditModal?.component}</>;
};

export default EditSignedAgreement;
